import React from "react"
import ReactDOM from "react-dom"
import ImpressionBlockComponent from "./impression-block-component"

export default class ImpressionBlock {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ImpressionBlockComponent {...this.modelJson} />, self.elem)
  }
}
